import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const loanPurposeMap: Record<LoanPurpose, MapItem> = {
  purchase: { label: 'Purchase' },
  refinance: { label: 'Refinance' },
  other: { label: 'Other' },
}

export const loanPurposeSchema = z.enum(Object.keys(loanPurposeMap) as [LoanPurpose, ...LoanPurpose[]])

export type LoanPurpose = 'purchase' | 'refinance' | 'other'

export enum LoanPurposeEnum {
  PURCHASE = 'purchase',
  REFINANCE = 'refinance',
  OTHER = 'other',
}
